import { Component, h, Prop, Event, EventEmitter, Method, Element, Host } from "@stencil/core";

@Component({
  tag: "nj-dialog",
  styleUrl: "nj-dialog.scss",
  shadow: true
})
export class NjDialog {
    @Element() el: HTMLElement;

    @Prop() public dialogTitle: string;
    @Prop({ mutable: true, reflect: true }) visible: boolean = false;

    @Event() okSubmitted: EventEmitter;
    @Event() cancelSubmitted: EventEmitter;
    @Event() dialogClosed: EventEmitter;
    @Event() dialogOpen: EventEmitter;

    private closeButton: HTMLButtonElement;

    componentDidLoad() {
        this.closeButton = this.el.shadowRoot.querySelector('.nj-dm-btn-close')
    }

    private handleCancelClick = () => {
        this.hideDialog();
        this.cancelSubmitted.emit();
    };


    @Method()
    async toggle() {
        if (this.visible) {
            this.hideDialog();
        } else {
            this.showDialog();
        }
    }

    @Method()
	async show() {
        this.showDialog();
	}

	@Method()
	async hide() {
		this.hideDialog();
	}

    private readonly showDialog = () => {
        if (this.visible) return;

        this.visible = true;
        this.dialogOpen.emit({
            element: this.el
        })

        setTimeout(() => {
            this.closeButton?.focus()
        }, 350) // wait for css animation
    }

    private readonly hideDialog = () => {
        if (!this.visible) return;

        this.visible = false;

        this.dialogClosed.emit({
            element: this.el
        })
    }

    render()  {
        return (
            <Host tabIndex={!this.visible ? -1 : null }>
                <div class={this.visible ? "nj-dm-overlay visible" : "nj-dm-overlay"}>
                    <div class="nj-dm-dialog__header">
                        <button type="button" aria-label="Close" class="nj-dm-btn-close" onClick={() => this.handleCancelClick()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="nj-dm-dialog">
                        <div class="nj-dm-dialog__container">
                            <div class="nj-dm-dialog__content">
                                {this.dialogTitle ? <h2 class="title">{this.dialogTitle}</h2> : ""}
                                <slot />
                            </div>
                        </div>
                    </div>
                </div>
            </Host>
        )
    }
}